<template>
  <v-card outlined>
    <v-card-text>
      <div class="caption mb-1">
        {{ data.event && data.event.start_at ? $dayjs(data.event.start_at).format(getDateTimeFormatForUser('D MMM, YYYY HH:mm')) : $dayjs(data.event_at_date).format(getDateTimeFormatForUser('D MMM, YYYY')) }}
        <span
          v-if="data.event"
          class="ml-1"
        >
          &middot; {{ data.event.title }}
          &middot;
          <strong>
            {{ $dayjs(data.event.end_at).diff($dayjs(data.event.start_at), 'm') }} min
          </strong>
        </span>
      </div>
      <v-row
        no-gutters
        align="center"
      >
        <v-col
          v-if="data.training_protocol"
          class="text-body-1 font-weight-medium"
        >
          {{ data.training_protocol.name }}
        </v-col>
        <v-spacer />
        <v-col cols="auto">
          <v-chip
            label
            small
            class="mr-1"
          >
            <strong class="mr-1"> {{ getOrdinal(data.order) }} </strong> {{ $t("training_builder.exercise.lowercase") }}
          </v-chip>
          <v-chip
            v-if="data.superset"
            label
            small
            class="mr-1"
          >
            {{ $t("preposition.in") }}<strong class="mx-1">{{ $t("training_builder.superset.lowercase") }}</strong> <span v-if="data.order_in_superset">({{ getOrdinal(data.order_in_superset) }})</span>
          </v-chip>
        </v-col>
      </v-row>
      <v-divider class="my-3" />

      <exercise-params-view-template
        :sets="data.params.sets"
        :group-id="trainingExerciseGroupId"
        :params="data.params"
        has-realizations
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { TrainingExerciseGroupId } from '@/data/models/TrainingExercise'
import ExerciseParamsViewTemplate from '@/components/training-builder/ExerciseParamsViewTemplate.vue'
import { getOrdinal, getDateTimeFormatForUser } from '@/utils/helpers'

export default {
  name: 'PlayerExerciseHistoryDialogRow',
  components: { ExerciseParamsViewTemplate },
  props: {
    data: {
      type: Object,
      required: true
    },
    player: {
      type: Object,
      default: () => ({})
    },
    trainingExerciseGroupId: {
      type: String,
      required: true
    }
  },
  created() {
    this.groupIds = TrainingExerciseGroupId
  },
  methods: { getDateTimeFormatForUser, getOrdinal }
}

</script>

<style scoped>

</style>
